import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import CustomerFilterPill from '../../../../components/actionable-filter-pill/connected/orders/customer';
import { messages } from './messages';

export const Customer = {
  id: 'customer',
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK,
  displayName: <FormattedMessage {...messages.customer} />,
  filterValue: 'customerId',
  expectsArgumentAsArray: true,
  hideWhenInactive: true,
  render: () => null,
  actionableFilterPill: CustomerFilterPill,
};
